import React, { Component } from 'react';
import { format } from "date-fns";
import { Big3DatePicker } from "../../../js/ComponentManager";
import { Big3Common } from '../../../js/IncludeManager'

/* 개발담당:이재호
 * 화면기능:마이페이지 > 처리내역
 * 세부설명:
*/

export class ProcessMgrList extends Component {
    static displayName = ProcessMgrList.name;

    constructor(props) {
        super(props);

        let fromDate = format(Big3Common.Util.DateAdd(new Date(), -3), "yyyy-MM-dd");
        let toDate = format(Big3Common.Util.DateAdd(new Date(), 1), "yyyy-MM-dd");
        this.state = {
            FromDate: fromDate,
            ToDate: toDate,
            Search_Text: "",
            BillCnt: "",
            ProcessCnt: "",
            TotalAmount: "",
            ProcessList: []
        };
        this.CsName = Big3Common.ContentState;
        this.handleCalenderChange = this.handleCalenderChange.bind(this);
        this.handleSearch_Click = this.handleSearch_Click.bind(this);
        this.handleSearch_Blur = this.handleSearch_Blur.bind(this);
        this.handle_KeyDown = this.handle_KeyDown.bind(this);
        this.handleDelete_Click = this.handleDelete_Click.bind(this);
    }
    //초기화
    componentDidMount() {
        this.GetProcessList();
    }

    //처리내역 가져오기
    async GetProcessList(Search_Text) {
        try {
            Big3Common.Util.LoadingOn();
            const Data = await Big3Common.Post('api/MyPage/MyInfoMgr/GetProcessList',
                {
                    order_st_dt: this.state.FromDate,
                    order_end_dt: this.state.ToDate,
                    Search_Text: Search_Text !== "" ? Search_Text : this.state.Search_Text,
                }, true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                const DataList = JSON.parse(Data.multiDataTable);
                const ProcessList = DataList.dtProcessList;
                //날짜별 청구건수, 처수건수
                const BillCnt = DataList.dtProcessListTypeTotal[0].cnt;
                const ProcessCnt = DataList.dtProcessListTypeTotal[1].cnt;
                const TotalAmount = DataList.dtProcessListTotalAmount[0].total;
                this.setState({
                    ProcessList: ProcessList,
                    BillCnt: BillCnt,
                    ProcessCnt: ProcessCnt,
                    TotalAmount: TotalAmount
                });
            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("GetProcessList", e);
        }
        finally {
            Big3Common.Util.LoadingOff();
        }
    }

    //달력일자 선택
    handleCalenderChange(returnData) {
        this.setState({ [returnData.returnId]: returnData.SelectDate });
    }
    //검색
    handleSearch_Click() {
        this.GetProcessList(this.state.Search_Text);
        return false;
    }
    //검색 TextBox
    handleSearch_Blur(event) {
        const value = event.target.value;
        this.setState({ Search_Text: value });
        event.preventDefault();
    }
    //검색 엔터키
    handle_KeyDown(event) {
        if (event.key === 'Enter') {
            const value = event.target.value;
            this.GetProcessList(value);
            return false;
        }
    }
    //검색어 초기화
    handleDelete_Click(event) {
        this.setState({ Search_Text: "" });
        if (this.props.Blur !== undefined && this.props.Blur !== null) {
            this.props.Blur();
            event.preventDefault();
        }
        event.preventDefault();
    }
    //처리내역 엑셀 다운로드
    excelDownload = async (order_st_dt, order_end_dt) => {
        const date = order_st_dt.replace(/-/g, "") + " ~ " + order_end_dt.replace(/-/g, "");
        const fileName = `${date}_처리내역리스트`
        try {
            let Url = `api/MyPage/MyInfoMgr/ExcelDownload/${order_st_dt}/${order_end_dt}`;
            await Big3Common.FileDownLoad(Url, fileName);
        }
        catch (e) {
            console.log("ExcelDownload", e);
        }
    }
    Daterender = () => {
        const DataMaster = this.state.ProcessList;
        const DayGroups = Big3Common.Util.groupBy(DataMaster, list => list.order_dt);
        const ProcessDtListJson = [];
        for (const item of DayGroups.entries()) {
            ProcessDtListJson.push({
                "Ord_Dt": item[0],
                "ProcessList": item[1],
            });
        }
        return (
            <>
                {ProcessDtListJson.map((list, idx) =>
                    <div className="process_list_cover" key={idx}>
                        <div className="date">{list.Ord_Dt}</div>
                        {this.ProcessListrender(list.ProcessList)}
                    </div>
                )}
            </>
        )
    }
    ProcessListrender(ProcessList) {
        if (ProcessList.length === 0) {
            return false;
        }
        return (
            <table>
                <colgroup>
                    <col width="70%" />
                    <col width="30%" />
                </colgroup>
                {ProcessList.map((list, idx) =>
                    <tbody id="processList" key={idx}>
                    <tr>
                        <td>
                            {list.bld_name} ·{list.flr_name} ·{list.whole_no_name} ·{list.whole_name}
                        </td>
                        <td>
                            <div>{list.bag_count}EA</div>
                        </td>
                        <td>
                            <div>{list.lng_nm}</div>
                        </td>
                    </tr>
                    <tr>
                        {list.group_type === "A" && (
                            <td className="memo">
                                <div>{list.buy_memo}</div>
                            </td>
                        )}
                        {list.group_type === "B" && (
                            <td className="memo2">
                                <div>{list.buy_memo}</div>
                            </td>
                        )}
                        {list.group_type === "C" && (
                            <td className="memo1">
                                <div>{list.buy_memo}</div>
                            </td>
                        )}      
                        <td>
                            <div>{Big3Common.Util.Money(list.buy_amt)}원</div>
                        </td>
                    </tr>
                    </tbody>
                    )}
            </table>
        )
    }

    render() {
        const Daterender = this.Daterender();
        return (
            <div className="container_box p_margin u_padding orderlist_box">
                <div className="search_wrap">
                    <div className="search_input_box">
                        <input
                            type="text"
                            placeholder="도매명을 입력해주세요."
                            className="form-control"
                            onChange={this.handleSearch_Blur}
                            onKeyDown={this.handle_KeyDown}
                            onBlur={(e) => { this.handleSearch_Blur(e) }}
                            value={this.state.Search_Text}
                        />
                        <div className="search_btn" onClick={this.handleSearch_Click}></div>
                        <div className="search_delete" onClick={this.handleDelete_Click}></div>
                    </div>
                    <div className="select_date_box">
                        <div className="select_date_box_input">
                            <Big3DatePicker
                                className="form-control"
                                setDate={new Date(this.state.FromDate)}
                                DateChange={this.handleCalenderChange}
                                id="FromDate"
                            />
                            <div className="calendar_btn"></div>
                        </div>
                        <div className="select_date_box_input">
                            <Big3DatePicker
                                className="form-control"
                                setDate={new Date(this.state.ToDate)}
                                DateChange={this.handleCalenderChange}
                                id="ToDate"
                            />
                            <div className="calendar_btn"></div>
                        </div>
                        <button type="button" className="date_s_btn" onClick={() => { this.GetProcessList(this.state.Search_Text); }}>조회</button>
                    </div>
                </div>
                <div className="process_info_box">
                    <ul>
                        <li className="tit"><span>청구건수 :&nbsp;</span>  {this.state.BillCnt}건</li>
                        <li className="tit"><span>처수건수 :&nbsp;</span>  {this.state.ProcessCnt}건</li>
                        <li className="tit"><span>합계금액 :&nbsp;</span>  {Big3Common.Util.Money(this.state.TotalAmount)}원</li>

                    </ul>
                    <div className="excel_down" onClick={() => this.excelDownload(this.state.FromDate, this.state.ToDate)}></div>
                </div>
                <div className="process_list_box">
                    {Daterender}
                </div>

            </div>
        );
    }
}
